import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { WidgetSettingsDto } from '@/Domain/api/WIdget/dto/WidgetSetting.dto';
import { AnalyticsInsightsPage } from '@/UI/Insights/Analytics/AnalyticsInsights.page';

export const AnalyticsInsightsLoader = () => {
  const { isLoading } = useQuery<WidgetSettingsDto>({
    queryKey: [QueryKey.widgetSettings],
  });

  if (isLoading) return null;

  return <AnalyticsInsightsPage />;
};
